export default {
  selectAllLabel: 'Selecione Todos',
};
